export default "__VITE_ASSET__1d208969__"